import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { MasterySection } from '../components/MasterySection';
import { BonusSection } from '../components/BonusSection';
import { ComboSection } from '../components/ComboSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { DifferentiatorsSection } from '../components/DifferentiatorsSection';
import { AudienceSection } from '../components/AudienceSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { UrgencyBar } from '../components/UrgencyBar';
export function LandingPage() {
  return <div className="flex flex-col w-full pt-10 sm:pt-12" data-id="element-323">
      <UrgencyBar data-id="element-324" />
      <SocialProofPopup data-id="element-325" />
      <HeroSection data-id="element-326" />
      <ProblemSection data-id="element-327" />
      <SolutionSection data-id="element-328" />
      <MasterySection data-id="element-329" />
      <BonusSection data-id="element-330" />
      <ComboSection data-id="element-331" />
      <TestimonialsSection data-id="element-332" />
      <DifferentiatorsSection data-id="element-333" />
      <AudienceSection data-id="element-334" />
      <FAQSection data-id="element-335" />
      <FinalCTASection data-id="element-336" />
    </div>;
}